export const DIVA_ID = '604243d7b096bc00403fc57c';
export const DIVA_COMPANY_ID = '604243d7b096bc00403fc57b';
export const RUTHERFORD_ID = [
    '604244bcb096bc00403fc57f', // The Rutherford Group
    '609183bdf9da170052e63099' // The Rutherford Group - Freight
];


// WEBPACK FOOTER //
// ./src/constants/entities.js